import { render, staticRenderFns } from "./VirtualKeyboard80.vue?vue&type=template&id=c5026ed4&scoped=true&"
import script from "./VirtualKeyboard80.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard80.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard80.vue?vue&type=style&index=0&id=c5026ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5026ed4",
  null
  
)

export default component.exports